import { Box } from '@material-ui/core'
import Button from '@mui/material/Button'

export const FixedMainButton = ({ title, handleOnClick }) => (
  <>
    <Box
      sx={{
        height: '20px',
        width: '100%',
        backgroundColor: 'white',
        zIndex: 1000,
        position: 'fixed',
        bottom: 20,
      }}
    ></Box>
    <Button
      variant="contained"
      color="success"
      onClick={handleOnClick}
      sx={{
        borderRadius: 0,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        zIndex: 1000,
      }}
    >
      {title}
    </Button>
  </>
)
